import { render, staticRenderFns } from "./peace.vue?vue&type=template&id=2ad74eac&scoped=true"
import script from "./peace.vue?vue&type=script&lang=js"
export * from "./peace.vue?vue&type=script&lang=js"
import style0 from "./peace.vue?vue&type=style&index=0&id=2ad74eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad74eac",
  null
  
)

export default component.exports